// interface

import { useParams as useReactRouterParams } from 'react-router-dom';

export const useParams = <T>() => {
  const rawParams = useReactRouterParams();

  const params: Record<string, number | string | undefined> = {};
  for (const [key, value] of Object.entries(rawParams)) {
    const asNumber = Number(value);
    params[key] = isNaN(asNumber) ? value : asNumber;
  }

  return params as T;
};
